import Vue from 'vue'
import { Settings } from 'luxon'

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('datetime', Datetime)
Settings.defaultLocale = 'es'
